import { render } from "./print-gaji-tetap-OK.vue?vue&type=template&id=ecef7e8a&scoped=true"
import script from "./print-gaji-tetap-OK.vue?vue&type=script&lang=js"
export * from "./print-gaji-tetap-OK.vue?vue&type=script&lang=js"

import "./print-gaji-tetap-OK.vue?vue&type=style&index=0&id=ecef7e8a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecef7e8a"]])

export default __exports__